
/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/

$(function() {


    // $('.contactForm').submit(function(ev) {
    //     // Prevent the form from actually submitting
    //     ev.preventDefault();
    //
    //     console.log("fuck yoiu");
    //
    //
    //
    //     // Send it to the server
    //     $.post({
    //         url: '/',
    //         dataType: 'json',
    //         data: $(this).serialize(),
    //         success: function(response) {
    //             if (response.success) {
    //                 // remove loading and show success message
    //                 console.log("success");
    //                 var tempcontent = "<h4 class='alert-heading'>Thank you very much!</h4><p>We usually reply within 24 hours.</p>";
    //                 $(".response").show();
    //                 $(".response").html(tempcontent);
    //                 $('.contactForm').hide();
    //             } else {
    //                 // response.error will be an object containing any validation errors that occurred, indexed by field name
    //                 // e.g. response.error.fromName => ['From Name is required']
    //                 // alert('An error occurred. Please try again.');
    //                 // $.each( response.errors, function( index, value ){
    //                 //     // sum += value;
    //                 //     console.log(index + " : " + value);
    //                 // });
    //
    //                 $('.response').addClass('alert-danger').removeClass('alert-success');
    //                 $(".response").show();
    //                 $.each(response.errors, function(field, msgs){
    //                     var tempcontent = msgs.toString();
    //                     $(".response").append(tempcontent + "<br>");
    //                 });
    //
    //
    //
    //             }
    //         }
    //     });
    // });


});



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/src/script.js
// module id = 82
// module chunks = 0